import React, {
  ReactElement,
  cloneElement,
  createContext,
  useContext,
  useState,
} from "react";

interface GlobalContextValue {
  data: any;
  updateData: (keyOrObj: string | object, value?: any) => void;
}

export const GlobalContext = createContext<GlobalContextValue>({
  data: {},
  updateData: () => {},
});

export const useGlobalContext = () => useContext(GlobalContext);

export const GlobalProvider = ({ children }: { children: ReactElement }) => {
  const [data, setData] = useState<any>({
    openVehicleStatus: false,
    openVehicleLedger: false,
    openLogo: false,
    selectedLogo: null,
    openAdvanceBalance: false,
    openSyncCollection: false,
    openCalculateWage: false,
    staffId: null as string | null,
  });

  const renderBody = (ele: ReactElement) => cloneElement(ele);
  const updateData = (keyOrObj: string | object, value?: any) => {
    setData((prevData: any) => {
      if (typeof keyOrObj === "object" && keyOrObj !== null) {
        // Handle object updates: updateData({ key1: value1, key2: value2 })
        return {
          ...prevData,
          ...keyOrObj,
        };
      } else {
        // Handle single key-value updates: updateData('key', value)
        return {
          ...prevData,
          [keyOrObj as string]: value,
        };
      }
    });
  };

  const contextValue = { data, updateData };

  return (
    <GlobalContext.Provider value={contextValue}>
      {renderBody(children)}
    </GlobalContext.Provider>
  );
};
